export const amenitiesInitialState = {
    loading: false,
    data: [],
    error: '',
};
